<template>
<van-popup
    v-model="visible"
    position="bottom"
    :overlay="false"
>
    <div class="login" @click="bgClickHandle">
        <div class="login__panel" @click.stop>
			<div class="progress">
				<div class="progress_indicator progress_indicator_mark"></div>
				<div class="progress_indicator"></div>
				<div class="progress_indicator"></div>
			</div>
            <!-- <div class="login__title">
                <span>SIGN UP & EARN $75</span>
            </div> -->
            <!-- <img
                v-if="!isWx"
                class="login__panel_close"
                @click="visible = false"
                :src="require('@/assets/imgs/close.png')"
            /> -->
            <!-- <hr class="login__line" /> -->
            <div class="login__content">

                <!-- 手机登录 begin -->
                <template>

                    <!-- <div class="login__brand">
                        <img src="@/assets/imgs/logo.png" alt="" />
                        <span>{{ $t("message.login.brandName") }}</span>
                    </div> -->
                    <!-- <img
                        v-if="!isWx"
                        class="login_panel_btn_back global_pointer"
                        @click="visible = false"
                        :src="require('@/assets/imgs/login/icon-back.png')"
                    /> -->
                    <dl v-if="inviteUserInfo" class="invite-info">
                        <dd class="photo"  :style="{backgroundImage: `url(${ (inviteUserInfo && inviteUserInfo.headImg && inviteUserInfo.headImg.url )|| 'https://fr-static.shopshops.top/20220610/photo.40042c4b908535b2.png' })`}"></dd>
                        <dt>
                            <img class="star star-left" src="https://fr-static.shopshopslive.com/20220902/StarsLeft.dc6c2a44cd7a66d5.svg" alt="">
                            <img class="star star-right" src="https://fr-static.shopshopslive.com/20220902/StarsRigh.26a88584e67c37f7.svg" alt="">
                            {{ $t('message.shareEarn.expiresInfo', {username: inviteUserInfo && inviteUserInfo.userName}) }}
                        </dt>
                    </dl>

                    <div :class="{'sign-up-title': !inviteUserInfo}">{{ $t('message.login.title') }}</div>
					<div v-if="loginType === 1" :class="{'sign-up-subtitle': !inviteUserInfo}">{{$t('message.login.subtitle')}}</div>
					<div v-if="loginType === 2" :class="{'sign-up-subtitle': !inviteUserInfo}">{{$t('message.login.emailSubtitle')}}</div>
                    <div class="phone_login_content">
                        <div class="login__form">
                            <div class="login__form_item" :class="{'login__form_item-input':!((loginType === 1&&loginErrorInfo!=null)||(loginType === 2&&emailLoginErrorInfo!=null))}">
                                <template v-if="loginType === 1">
                                    <span class="area global_pointer" @click="chooseCountryCode"
                                        >+{{ countryCode }}</span
                                    >
									<img
										:src="require('@/assets/imgs/login/pulldown.png')"
										class="login__verify__pulldown global_pointer"
										@click="chooseCountryCode"
									/>
                                    <input
                                        ref="mobile"
                                        type="text"
                                        v-model="mobile"
                                        :placeholder="$t('message.login.mobile')"
                                        maxLength="11"
                                        minLength="11"
                                        @blur="onBlur"
                                        @focus="onFocus"
                                        autocomplete="new"
                                    />

									<img v-if="mobile.length>0" class="input_clear_btn global_pointer" @click="clearInput" src="@/assets/imgs/login/input_clear.png" /> 
									
                                </template>
                                <template v-if="loginType === 2">
                                    <span class="area">Email</span>
                                    <input
										style="border-left: 1px solid #979797;"
                                        type="text"
                                        v-model="email"
                                        :placeholder="$t('message.login.email')"
                                        @blur="onBlur"
                                        @focus="onFocus"
                                        autocomplete="new"
                                    />
									<img v-if="email.length>0" class="input_clear_btn global_pointer" @click="clearInput" src="@/assets/imgs/login/input_clear.png" />
                                </template>
                            </div>
							<div class="login__form_item-errorinfo" v-if="loginType === 1&&loginErrorInfo!=null">
								<div class="login__form_item-errorinfo_icon">!</div>
								<div class="login__form_item-errorinfo_text">{{loginErrorInfo}}</div>
							</div>
							<div class="login__form_item-errorinfo" v-if="loginType === 2&&emailLoginErrorInfo!=null">
								<div class="login__form_item-errorinfo_icon">!</div>
								<div class="login__form_item-errorinfo_text">{{emailLoginErrorInfo}}</div>
							</div>
							

                            <!-- <div class="login__form_item login__form_item-button" @click="showVerifyAction"> -->
                            <div :class="loginType==1&&mobile.length>0||loginType==2&&email.length>0?'login__form_item-button':'login__form_item-button-disable'"
                                class="login__form_item global_pointer"
                                @click="getCode"
                            >
                                {{ $t("message.login.getVerifyCodeFull") }}
                            </div>

                            <!-- <p class="_desc">
                                {{ $t('message.login.rewardTips') }}
                            </p> -->
                        </div>

                        <div class="login__other">
                            Or <span class="global_pointer" v-if="loginType === 1" @click="changeLoginType(2)">Use Email</span>
                            <span class="global_pointer" v-if="loginType === 2" @click="changeLoginType(1)">Use Phone Number</span>
                        </div>

                        <div class="login__bottom">

                            <div class="login__bottom_item"  v-if=" $i18n.locale == 'en' && isShowSignUpText ">
                                <div class="global_pointer" @click="toggleSelect1" v-if="checkSelect1">
                                    <img src="@/assets/imgs/login/checked.png" />
                                </div>
                                <div class="checkbox" v-else @click="toggleSelect1">&nbsp;</div>
                                <div>
                                    <!-- <div class="login__bottom_item_checktext _title" @click="toggleSelect1">
                                        {{ $t("message.login.terms1") }}
                                    </div> -->
                                    <div class="login__bottom_item_checktext_desc global_pointer" @click="toggleSelect1">
                                        {{ $t("message.login.terms2") }}
                                    </div>
                                </div>
                            </div>
                            <div class="login__bottom_item __conditions_box">
                                <!-- <div class="_checkbox_wrap" @click="toggleSelect">
                                    <img
                                        v-if="checkSelect"
                                        src="@/assets/imgs/login/checked.png"
                                        alt=""
                                    />
                                    <div :class="`checkbox ${isRed? 'red':''}`" v-else></div>
                                </div> -->
                                <div>
                                    <template v-if="$i18n.locale =='en' ">
                                        <span class="global_pointer" @click="toggleSelect">
                                            By signing up you agree to the
                                        </span>
                                        <span>
                                            <a :href="$t('message.login.Termslink')">
                                                {{ $t("message.login.Terms") }}
                                            </a>
                                            and
                                        </span>
                                        <span>
                                            <a :href="$t('message.login.Policylink')" >
                                                {{ $t("message.login.Policy") }}
                                            </a>
                                        </span>
                                    </template>
                                    <template v-else>
                                        <span >
                                            <span class="global_pointer" @click="toggleSelect">登录即代表阅读并同意</span><i @click="getRegisterConditions(0)">《用户注册协议》</i>和<i  @click="getRegisterConditions(1)">《隐私政策》</i>
                                            <!-- {{ $t("message.login.terms")}} -->
                                        </span>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <!-- 手机登录 end -->

				<template v-if="loginType === 3">
					<img
						v-if="emailStatus <= EMAIL_STATUS.SIGNUP_1"
						class="login__email-back global_pointer"
						src="@/assets/imgs/login/icon-back.png"
						alt=""
						@click="emailBack"
					/>
					<div class="login__Email">
						<img src="@/assets/imgs/login/mail_new.png" alt="" />
						<span v-if="emailStatus == EMAIL_STATUS.FORGOT">{{
							$t("message.login.forgot")
						}}</span>
						<span v-if="emailStatus >= EMAIL_STATUS.SIGNUP_1">{{
							$t("message.login.signup!")
						}}</span>
					</div>
					<template v-if="emailStatus == EMAIL_STATUS.LOGIN">
						<div class="login__form">
							<div class="login__form_item">
								<input
									type="text"
									class="email"
									v-model="email"
									:placeholder="$t('message.login.email')"
									@blur="onBlur"
									@focus="onFocus"
									autocomplete="new"
								/>
							</div>
							<div
								class="
									login__form_item login__form_item_password
								"
							>
								<input
									class="vcode"
									type="password"
									v-model="password"
									:placeholder="$t('message.login.password')"
									maxLength="20"
									minLength="8"
									@blur="onBlur"
									@focus="onFocus"
								/>
								<div
									class="login__form_button-forgot global_pointer"
									@click="gotoForgot"
								>
									{{$t('message.login.forgot?')}}
								</div>
							</div>
							<div
								class="
									login__form_item login__form_item_container
								"
							>
								<div
									class="
										login__form_item-button
										login__form_item-button-half
										global_pointer
									"
									@click="emailLogin"
								>
									{{ $t("message.login.login") }}
								</div>
								<div
									class="
										login__form_item-button
										login__form_item-button-half
										login__form_item-button-sign_up
										global_pointer
									"
									@click="gotoSignUp"
								>
									{{ $t("message.login.signup") }}
								</div>
							</div>
						</div>
					</template>
					<template v-if="emailStatus == EMAIL_STATUS.FORGOT">
						<div class="login__form">
							<div class="login__form_item">
								<input
									type="text"
									class="email"
									v-model="email"
									:placeholder="$t('message.login.email')"
									@blur="onBlur"
									@focus="onFocus"
								/>
							</div>
							<div class="login__form_item">
								<input
									class="vcode"
									type="text"
									v-model="checkCode"
									:placeholder="
										$t('message.login.verifyCode')
									"
									maxLength="6"
									minLength="6"
									@blur="onBlur"
									@focus="onFocus"
								/>
								<div
									class="login__form_button-vcode global_pointer"
									:class="{ disable: codeDisable }"
									@click="sendMCode(1)"
								>
									{{
										countTime == 120
											? $t("message.login.getVerifyCode")
											: ""
									}}{{
										countTime < 120
											? "(" + countTime + ")"
											: ""
									}}
								</div>
							</div>
							<div class="login__form_item">
								<input
									class="vcode"
									type="password"
									v-model="password"
									:placeholder="
										$t('message.login.newPassword')
									"
									maxLength="20"
									minLength="8"
									@blur="onBlur"
									@focus="onFocus"
								/>
							</div>
							<div
								class="login__form_item login__form_item-button global_pointer"
								@click="emailReset"
							>
								{{ $t("message.login.login") }}
							</div>
						</div>
					</template>
					<template v-if="emailStatus == EMAIL_STATUS.SIGNUP_1">
						<div class="login__form">
							<div class="login__form_item">
								<input
									type="text"
									class="email"
									v-model="email"
									:placeholder="$t('message.login.email')"
									@blur="onBlur"
									@focus="onFocus"
								/>
							</div>
							<div class="login__form_item">
								<input
									class="vcode"
									type="text"
									v-model="checkCode"
									:placeholder="
										$t('message.login.verifyCode')
									"
									maxLength="6"
									minLength="6"
									@blur="onBlur"
									@focus="onFocus"
								/>
								<div
									class="login__form_button-vcode global_pointer"
									:class="{ disable: codeDisable }"
									@click="sendMCode(2)"
								>
									{{
										countTime == 120
											? $t("message.login.getVerifyCode")
											: ""
									}}{{
										countTime < 120
											? "(" + countTime + ")"
											: ""
									}}
								</div>
							</div>
							<div
								class="login__form_item login__form_item-button global_pointer"
								@click="gotoSignUp2"
							>
								{{ $t("message.login.signup") }}
							</div>
							<div class="login__form_email_status">
								<span
									class="login__form_email_status_solid"
								></span>
								<span
									class="login__form_email_status_hollow"
								></span>
							</div>
						</div>
					</template>
					<template v-if="emailStatus == EMAIL_STATUS.SIGNUP_2">
						<div class="login__form">
							<div class="login__form_item">
								<input
									class="vcode"
									type="password"
									v-model="password"
									:placeholder="$t('message.login.password')"
									maxLength="20"
									minLength="8"
									@blur="onBlur"
									@focus="onFocus"
								/>
							</div>
							<div class="login__form_item">
								<input
									class="vcode"
									type="password"
									v-model="confirmPassword"
									:placeholder="
										$t('message.login.confirmPassword')
									"
									maxLength="20"
									minLength="8"
									@blur="onBlur"
									@focus="onFocus"
								/>
							</div>
							<div
								class="login__form_item login__form_item-button global_pointer"
								@click="emailRegister"
							>
								{{ $t("message.login.signup") }}
							</div>
							<div class="login__form_email_status">
								<span
									class="login__form_email_status_hollow"
								></span>
								<span
									class="login__form_email_status_solid"
								></span>
							</div>
						</div>
					</template>
				</template>

			</div>
		</div>
		<div class="login__code_select" v-if="showCountryCode" @click.stop>
			<div class="country-code-box">
				<div
					class="country-code"
					v-for="(item, index) in phoneCodeList"
					:key="index"
				>
					<p class="title">{{ en ? item.title : item.titleZh }}</p>
					<ul class="item-list">
						<li
							v-for="(itemCode, indexCode) in item.list"
							:key="indexCode"
							class="global_pointer"
							@click="chooseNum(itemCode.code)"
						>
							<span class="name">{{
								en ? itemCode.name : itemCode.nameZh
							}}</span>
							<span class="code">+{{ itemCode.code }}</span>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<!-- verifyFocus -->
		<van-popup
			v-model="showVerify"
            position="center"
			:class="['login__verify', { 'login__verify-focus': true }]"
			:close-on-click-overlay="false"
			@click.stop
		>
			<img
				:src="require('@/assets/imgs/close.png')"
				class="login__verify__close global_pointer"
				@click="showVerify = false"
			/>
			<div class="login__verify__title">
				<span>{{ $t('message.login.verifyCodeTitle') }}</span>
			</div>
			<div class="login__verify__sub_title" v-if="loginType === 2">
				{{ $t('message.login.emailVerfifyCodeSended') }}
			</div>
			<div class="login__verify__sub_title" v-else>
				{{ $t('message.login.verfifyCodeSended') }}
			</div>
			<input
				class="login__verify__input"
				ref="myInput"
				v-model="verifyCode"
				autofocus
				@blur="verifyFocus = false"
			/>
			<div class="login__verify__body global_pointer" :class="{'login__verify__body-email':loginType === 2 }" @click="verifyClickHandle">
				<label
					:class="[
						'login__verify__item',
						{
							'login__verify__item-active':
								verifyFocus && index === verifyCurrent,
						},
						{
							'login__verify__item-email':
								loginType === 2,
						}
					]"
					for="code"
					v-for="(item, index) in (loginType === 1 ? 6 : 4)"
					:key="index"
					v-text="verifyList[index]"
				>
				</label>
			</div>
			<div class="login__verify__send">
				{{ countTime==120 ? $t('message.login.verifyCodeUnRecvice') : ""}}
				<span :class="countTime == 120 ? 'login__verify__send__resend global_pointer':'login__verify__send__second'" @click="sendVCode">
					{{ countTime == 120 ? $t('message.login.verifyCodeResend') : "" }}
					{{ countTime < 120 ? countTime + "s" : "" }}
				</span>
			</div>

			<div class="m-load2">
				<div class="line">
					<div></div>
					<div></div>
					<div></div>
					<div></div>
				</div>
				<div class="circlebg"></div>
			</div>
			
		</van-popup>

		<!-- 图片验证码 -->
		<imgCode
			class="global_pointer"
			:mobile="mobile"
			ref="imgCode"
			@getInfoCode="getInfoCode"
			@cancel="showDialog = false"
		/>
		<!-- <van-number-keyboard
      :z-index="9999"
      :show="verifyFocus"
      @blur="verifyFocus = false"
      @input="onVerifyFocusInput"
      @delete="onVerifyFocusDelete"
    /> -->
		<van-popup
			closeable
			position="bottom" 
			:style="{ height: '60%' }" 
			v-model="showRegisterConditions"
			:close-on-click-overlay="false"
			@closed="onCloseRegisterConditions"
			:round="true"
		>
			<div  class="conditions_content" v-if="registerConditions" v-html="registerConditions.content"></div>
		</van-popup>
	</div>
</van-popup>
</template>
<script>
import api from "@/api/api_list";
import request from "@/api/request/request.js"
import { getDeviceId, plateForm, getQueryObj, CURRENT_HOST_NAME } from "@/utils";
import phoneCodezh from "@/config/PhoneCodezh.json";
import phoneCode from "@/config/PhoneCode.json";
import imgCode from "@/components/imgCode";

const EMAIL_STATUS = {
	LOGIN: 1, // 登录状态
	FORGOT: 2, // 修改密码状态
	SIGNUP_1: 3, // 注册第一步
	SIGNUP_2: 4, // 注册第二步
};
const isWx = plateForm().os === "wxClient";
export default {
	name: "login",
	components: {
		imgCode,
	},
	data() {
		return {
			showRegisterConditions:false,
			registerConditions: null,
			showDialog: false,
			mobile: "",
			checkCode: "",
			// 发送验证码的倒计时 flag
			interval: 0,
			countTime: 120,
			codeDisable: false,
			relationInfo: null,
			checkSelect: true,
			checkSelect1: false,
			countryCode: this.$i18n.locale === "en" ? 1 : 86,
			en: this.$i18n.locale === "en",
			// phoneCodeList: this.$i18n.locale === "en" ? phoneCode.data : phoneCodezh,
			phoneCodeList: this.$i18n.locale === 'en' ? phoneCode.data : phoneCodezh.data,
			showCountryCode: false,
			ZHBUrl: "",
			isWx,
			// 登录方式 1：手机； 2：邮箱
			loginType: 1,
			email: "",
			password: "",
			confirmPassword: "",
			emailStatus: EMAIL_STATUS.LOGIN,
			EMAIL_STATUS,
			visible: false,
			path: "",
			vm: null,
			inviteCode: null,
			loginSuccess: null,
			showVerify: false,
			verifyFocus: false,
			verifyCode: "",
			verifyDisable: false,
			isRed: false,
            inviteUserInfo: null,
			loginErrorInfo: null,
			emailLoginErrorInfo: null,
            // 是否展示登录 注册下边的奖励选项
			isShowSignUpText: false,
			signupTextCountryCodeList: [],
            inviteUserInfo: null,
		};
	},
    created(){

		// 登录弹窗在微信 或 中文环境 默认选中+86
		// 需求来源 http://wiki.shopshops.top:8080/browse/SSSTASK-111
		const isWX = navigator.userAgent.toLocaleLowerCase().indexOf('micromessenger') !== -1;
		// const isZH = navigator.language.startsWith( 'zh-');
		if( isWX ){
			this.countryCode = 86;
		}
		
		this.getPolicyStatus();
    },
	mounted() {
        let query = getQueryObj();
        
        if (!query.userNum) {
            return;
        }
        if (query.code && query.activityType === 'inviteCode') {
            this.getInviteUserInfo( query.userNum );
        }
	},

	methods: {
        async getInviteUserInfo( userNum ) {
            try {
                let {code , msg, result} = await api.get_user_info_by_user_num({
                    userNum: userNum
                });
                if (
                    code ===0 &&
                    result &&
                    result.intgUser &&
                    result.intgUser.userNum
                ) {
                    this.inviteUserInfo = result.intgUser;
                }
            } catch (e) {
                console.log(e);
            }
        },
		async getPolicyStatus() {
			try{
				const {code ,result} = await api.get_list_config({
					dictType: "LoginPageText",
				});
				if(code === 0 && result && result[1] && result[1].dictName){
					this.signupTextCountryCodeList = JSON.parse(result[1].dictName);
					this.setPolicyShowStatus();
				}
			}catch(e){
				console.log(e)
			}
		},
		async setPolicyShowStatus(){
			if( this.signupTextCountryCodeList.includes( '+'+this.countryCode )){
				this.isShowSignUpText = true;
			}else{
				this.isShowSignUpText = false;
			}
		},
		onCloseRegisterConditions(){
			this.registerConditions = null;
		},
		async getRegisterConditions(type){
			let res = await request.get(
				type==1 ? `https://api.${CURRENT_HOST_NAME}/app/agreement/get-content-by-key?type=100` :  `https://api.${CURRENT_HOST_NAME}/app/agreement/get-content-by-key?type=200`
			);
			if( res.code === 0 && res.result ){
				this.registerConditions = JSON.parse(res.result.content);
				this.showRegisterConditions = true;
			}
		},

		bgClickHandle() {
			if (this.showVerify || this.isWx || this.registerConditions) return;
			this.visible = false;
		},
		// onVerifyFocusInput(v) {
		//   if (this.verifyCode.length >= 6) {
		//     this.verifyFocus = false
		//     this.verifyDisable = true
		//     return
		//   }
		//   this.verifyCode += v
		// },
		onVerifyFocusDelete() {
			this.verifyCode = this.verifyCode.slice(0, -1);
		},
		verifyClickHandle() {
			this.verifyFocus = true;
			this.$refs.myInput.focus();
		},
		showVerifyAction(params = {}) {
			let mobileReg = new RegExp(/^\d+$/g);
			if (
				!this.mobile ||
				(this.countryCode == 86 && this.mobile.length != 11) ||
				!mobileReg.test(this.mobile)
			) {
				this.$toast(this.$t("message.login.tips.yourNumber"));
				return;
			}
			if (!this.checkSelect) {
				this.$toast(this.$t("message.login.tips.yourSelect"));
				return;
			}
			this.showVerify = true;
			this.$nextTick(() => {
				this.verifyFocus = true;
				// this.$refs.myInput.focus()
			});
			this.sendVCode(params);
		},

		// 获取短信验证码
		async getCode() {
            if (this.loginType === 2) {
                this.sendMCode(3);
                return
            }
            let mobileReg = new RegExp(/^\d+$/g);
            if (
                !this.mobile ||
                (this.countryCode == 86 && this.mobile.length != 11) ||
                !mobileReg.test(this.mobile)
            ) {
                this.$toast(this.$t("message.login.tips.yourNumber"));
				this.loginErrorInfo = this.$t("message.login.tips.yourNumber")
                return;
            }
			if (!this.checkSelect) {
				this.isRed = true;
				this.$toast(this.$t("message.login.tips.yourSelect"));
				return;
			}
			this.$refs.imgCode.getImgCode();

			try{
				fbq('track', 'GetMobileVerificationCode');
			}catch(e){
				console.log('error:fbq 不存在')
			}

			this.showDialog = true;
		},
		// 发送短信
		async getInfoCode(val = {}) {
			this.showDialog = false;
			this.gettingCode = true; //接口 有返回 释放

            let params = {
                ...val,
                countryCode: this.countryCode,
                mobile: this.mobile,
            };
            this.sendVCode(params);
			
			// try {
			//     const { code } = await this.sendVcode(params)
			//     if (!code) {
			//         this.imageCode = val;
			//         this.timer = 60
			//         this.interval = setInterval(() => {
			//             this.timer--
			//             if (this.timer <= 0) {
			//                 this.timer = 0
			//                 this.gettingCode = false
			//                 clearInterval(this.interval)
			//             }
			//         }, 1000)
			//     }
			// } catch (error) {
			//     setTimeout(() => {
			//         this.gettingCode = false
			//     }, 2000)
			// }
		},

		//todo
		sendVCode(params = {}) {
			if (this.countTime < 120) {
                this.showVerify = true;
				return;
			}
			let mobileReg = new RegExp(/^\d+$/g);
			if (
				!this.mobile ||
				(this.countryCode == 86 && this.mobile.length != 11) ||
				!mobileReg.test(this.mobile)
			) {
				this.$toast(this.$t("message.login.tips.yourNumber"));
				return;
			}
			this.codeDisable = true;
			api.send_v_code({
				...params,
				countryCode: this.countryCode,
				mobile: this.mobile,
			})
				.then((res) => {
					if (res.code == 0) {
						this.setCountDown(res);

						this.showVerify = true;

						this.$nextTick(() => {
							this.verifyFocus = true;
							this.$refs.myInput.focus()
						});
					} else {
						if (this.loginType==1) {
							this.loginErrorInfo=res.msg
						}else if (this.loginType==2) {
							this.emailLoginErrorInfo=res.msg
						}
						this.$toast(res.msg);
					}
				})
				.catch((err) => {
					this.countTime = 120;
					this.codeDisable = false;
				});
		},
		sendMCode(type) {
			if (this.countTime < 120) {
                this.showVerify = true;
				return;
			}
			let emailReg = new RegExp(/[\w\d]+@[\w\d]+\.[\w\d]+/g);
			if (!this.email || !emailReg.test(this.email)) {
				this.$toast(this.$t("message.login.tips.yourEmail"));
				this.emailLoginErrorInfo = this.$t("message.login.tips.yourEmail")
				return;
			}
			try{
				fbq('track', 'GetEmailVerificationCode');
			}catch(e){
				console.log('error:fbq 不存在')
			}

			this.codeDisable = true;
			api.send_e_code({
				sendSymbol: type, // 1,找回密码,2,邮箱注册 ,3, 邮箱登录
				targetEmailList: [this.email],
			})
				.then((res) => {
					if (res.code == 0) {
						this.setCountDown(res);

						this.showVerify = true;

						this.$nextTick(() => {
							this.verifyFocus = true;
							this.$refs.myInput.focus()
						});
					} else {
						this.emailLoginErrorInfo = res.msg
						this.$toast(res.msg);
					}
				})
				.catch((err) => {
					this.countTime = 120;
					this.codeDisable = false;
				});
		},
		setCountDown(res) {
			if (res.code === 0) {
				const _this = this;
				if (!this.interval) {
					this.interval = setInterval(() => {
						_this.countTime -= 1;
						if (_this.countTime <= 0) {
							this.resetInterval();
						}
					}, 1000);
				}
			} else {
				this.resetInterval();
				this.$toast(res.msg);
			}
		},
		emailRegister() {
			if (!this.checkSelect) {
				this.$toast(this.$t("message.login.tips.yourSelect"));
				return;
			}
			// if (
			// 	!this.password ||
			// 	!this.confirmPassword ||
			// 	this.password != this.confirmPassword
			// ) {
			// 	this.$toast(this.$t("message.login.tips.correctInfo"));
			// 	return;
			// }
			let emailReg = new RegExp(/[\w\d]+@[\w\d]+\.[\w\d]+/g);
			if (
				!this.email ||
				!this.verifyCode ||
				!emailReg.test(this.email)
			) {
				this.$toast(this.$t("message.login.tips.correctInfo"));
				return;
			}
			const defaultData = {
				// TODO: 此Id原版代码用的神策的用户id，之后确认具体取值
				anonymousId: this.$sa.store.getDistinctId() || "",
				appVersion: "0.0.0",
				deviceId: getDeviceId(),
				deviceModel: null,
				deviceSystem: 4,
				deviceVersion: "0.0.0",
				relationInfo: this.relationInfo, // TODO: 后续看原版代码确定取值
				loginIp: null,
			};
			api.email_register({
				...defaultData,
				email: this.email,
				checkCode: this.verifyCode,
				// password: this.password,
				inviteCode: this.inviteCode,
          		bindingSource: 'H5',
				// 是从activity?share_earn页面过来登录或注册的
				registerMethod: location.pathname.search('/activity/share_earn') !== -1  ? 'ReferralUser': ''
			}).then((res) => {
				if (res.code == 0) {
					this.setUser(res.result);
				} else {
					this.$toast(res.msg);
				}
			});
		},
		//todo
		mobileLogin() {
			if (!this.checkSelect) {
				this.isRed = true;
				this.$toast(this.$t("message.login.tips.yourSelect"));
				return;
			}
			let mobileReg = new RegExp(/^\d+$/g);
			if (
				!this.mobile ||
				!this.verifyCode ||
				!mobileReg.test(this.mobile)
			) {
				this.$toast(this.$t("message.login.tips.correctInfo"));
				return;
			}
			const defaultData = {
				// TODO: 此Id原版代码用的神策的用户id，之后确认具体取值
				anonymousId: this.$sa.store.getDistinctId() || "",
				appVersion: "0.0.0",
				deviceId: getDeviceId(),
				deviceModel: null,
				deviceSystem: 4,
				deviceVersion: "0.0.0",
				relationInfo: this.relationInfo, // TODO: 后续看原版代码确定取值
				loginIp: null,
			};

			api.mobile_login({
				...defaultData,
				mobile: this.mobile,
				checkCode: this.verifyCode,
				countryCode: this.countryCode,
				inviteCode: this.inviteCode,
          		bindingSource: 'H5',
				      
				// 是从activity?share_earn页面过来登录或注册的
				registerMethod: location.pathname.search('/activity/share_earn') !== -1  ? 'ReferralUser': ''
			}).then((res) => {
				this.verifyCode = "";
				this.showVerify = false;
				if (res.code == 0) {
					this.setUser(res.result);
				} else {
					this.resetInterval();
					this.$toast(res.msg);
				}
			});
			
		},

		// 登录成功后，都会调用此方法 向storage里存储用户信息
		async setUser(userInfo = {}) {

			const getUserInfo = () => {
				api.get_user_info().then((res) => {
					if (res.code === 0) {
						this.$storage.set("user_info", res.result.intgUser);
						let userNum = res.result.intgUser.userNum;
						if (userInfo) {
							window.__bl.pipe = [
								[
									"setConfig",
									{
										setUsername: function () {
											return userNum;
										},
									},
								],
							];
						}
					}
				});
			}

			const setInfo = (token, intgUser, register) => {
				if (!token || !intgUser) {
					return;
				}
				// sessionStorage.removeItem("inviteInfo");

				// 向stroage里存储信息
				this.$storage.set("user_token", token);
				this.$storage.set("user_info", intgUser);

				// 隐藏登录面板
				this.visible = false;

				// 从Stroage里取出userNum
				// inviteUserNum: 邀请人id， 如果当前用户被邀请过 此字段才会有值
				// const { userNum, inviteUserNum } = this.$storage.get('user_info') || {};
				if (register==1) {
					this.$createAccount.open({
						complete: (result) => {
							this.loginSuccess && this.loginSuccess();
							getUserInfo();
						}
					});
				}else{
					this.loginSuccess && this.loginSuccess();
					getUserInfo();
				}
			};

			const { token, intgUser,  register} = userInfo;
			setInfo(token, intgUser, register);

	


			

			api.get_yunxin_token().then((res) => {
				if (res.code === 0) {
					this.$storage.set("nim_token", res.result.netToken);
					this.$storage.set("net_account", res.result.netAccount);
				}
			});
		},

		// 支付宝登录
		async ZHBLogin() {
			const href = window.location.href.split("#_=_")[0];
			// const { code, result } = await ZFBauthLogin({
			//   anonymousId: this.$sa.store.getDistinctId() || '',
			//   type: 'ALIPAY1',
			//   backUrl: `${href}&form=alipay`, // 加上第三方登录标记
			// });
			api.ZFB_login({
				anonymousId: this.$sa.store.getDistinctId() || "",
				type: "ALIPAY1",
				backUrl: `${href}&form=alipay`, // 加上第三方登录标记
			}).then((res) => {
				const { code, result } = res;
				if (!code) {
					const schame =
						"alipays://platformapi/startapp?appId=20000067&url=";
					this.ZHBUrl = schame + encodeURIComponent(result);
				}
			});
		},
		facebookLogin() {
			// FB.getLoginStatus(function(response) {

			// {"authResponse":null,"status":"unknown","loginSource":null}
			// });
			if (!this.checkSelect) {
				this.isRed = true;
				this.$toast(this.$t("message.login.tips.yourSelect"));
				return;
			}

			FB.login(
				function (response) {
					console.log("FBlogin:" + JSON.stringify(response));
					if (response.status === "connected") {
						const { accessToken } = response.authResponse;
						api.facebook_login_state({
							type: "FACEBOOK1",
						})
							.then(
								function ({ code, result, msg }) {
									if (code == 0) {
										const state = result.state;
										return api.facebook_login({
											anonymousId:
												this.$sa.store.getDistinctId() ||
												"",
											type: "FACEBOOK1",
											state,
											code: accessToken,
										});
									} else {
										this.$toast(msg);
									}
								}.bind(this)
							)
							.then(
								function ({ code, result, msg }) {
									if (code == 0) {
										if (
											result.bindMobile &&
											result.bindMobile == 1
										) {
											result.intgUser.userWeixinId =
												result.userWeixinId;
											result.intgUser.userPartyId =
												result.userPartyId;
											result.intgUser.userAppleId =
												result.userAppleId;

											//需要绑定
											this.$bindMobile.open({
												token: result.token,
												userInfo: result.intgUser,
											});
										} else {
											//登录成功
											this.setUser(result);
											// this.$storage.set('user_token', result.token);
											// this.$storage.set('user_info', result.intgUser);
											this.$toast(
												this.$t(
													"message.profile.loginSuccess"
												)
											);
										}
									} else {
										this.$toast(msg);
									}
								}.bind(this)
							)
							.catch(
								function (e) {
									console.log(e);
									this.$toast(
										this.$t("message.profile.loginFail")
									);
								}.bind(this)
							);
					} else {
						this.$toast(this.$t("message.profile.loginFail"));
					}
				}.bind(this)
			);
		},
		appleIDLogin() {
			if (!this.checkSelect) {
				this.isRed = true;
				this.$toast(this.$t("message.login.tips.yourSelect"));
				return;
			}

			let redirect =
				`https://m-uat.${CURRENT_HOST_NAME}/uat-en/app/home/Live`;
			let clientId = "en.h5.shopshopslive.com";
			if (process.env.NODE_ENV === "production") {
				redirect =
					process.env.VUE_APP_APPLEID_LOGIN_CALLBACK ||
					`https://m.${CURRENT_HOST_NAME}/en/app/home/Live`;
				clientId =
					process.env.VUE_APP_APPLEID_LOGIN_CLIENTID ||
					"en.m.shopshopslive.com";
			}
			redirect = encodeURIComponent(redirect);
			let href = `https://appleid.apple.com/auth/authorize?client_id=${clientId}&redirect_uri=${redirect}&response_type=code id_token&response_mode=fragment&state=fromApple`;
			window.location.href = href;
		},
		toggleSelect() {
			this.checkSelect = !this.checkSelect;
			this.isRed = false;
		},
		toggleSelect1() {
			this.checkSelect1 = !this.checkSelect1;
		},
		chooseCountryCode() {
			this.showCountryCode = true;
		},
		closeCountryCode() {
			this.showCountryCode = false;
		},
		chooseNum(code) {
			this.countryCode = code;
			this.closeCountryCode();
			this.$refs.mobile.focus();

			this.setPolicyShowStatus();
		},
		changeLoginType(type) {
			this.verifyCode = '';
			try{
				this.resetInterval();
			}catch(e){}
			
			if (type == 2) {
				this.closeCountryCode();

				if (!this.checkSelect) {
					this.$toast(this.$t("message.login.tips.yourSelect"));
					return;
				}
			}
			this.loginType = type;
		},
		onFocus(evt) {
			// setTimeout(() => {
			//   document.getElementsByTagName('body')[0].style.height = `${window.innerHeight + 302}px`;
			//   document.body.scrollTop = 302;
			// }, 300);
			let element = evt.target;
			// element.scrollIntoView(true);
			element.scrollIntoViewIfNeeded(true);
		},
		// 输入框失去焦点事件
		onBlur() {
			// 设置body恢复原来的高度
			// document.getElementsByTagName('body')[0].style.height = `${window.innerHeight}px`;
		},
		gotoForgot() {
			this.emailStatus = EMAIL_STATUS.FORGOT;
			this.resetForm();
		},
		gotoSignUp() {
			this.emailStatus = EMAIL_STATUS.SIGNUP_1;
			this.resetForm();
		},
		gotoSignUp2() {
			this.emailCheck().then((res) => {
				this.emailStatus = EMAIL_STATUS.SIGNUP_2;
			});
		},
		emailBack() {
			if (
				this.emailStatus == EMAIL_STATUS.FORGOT ||
				this.emailStatus == EMAIL_STATUS.SIGNUP_1
			) {
				this.emailStatus = EMAIL_STATUS.LOGIN;
				this.resetInterval();
				this.resetForm();
			} else if (this.emailStatus == EMAIL_STATUS.LOGIN) {
				this.loginType = 1;
				this.resetForm();
			}
		},
		resetInterval() {
			clearInterval(this.interval);
			this.countTime = 120;
			this.codeDisable = false;
			this.interval = 0;
		},
		resetForm() {
			this.email = "";
			this.password = "";
			this.confirmPassword = "";
			this.checkCode = "";
			this.mobile = "";
		},
		emailCheck() {
			return new Promise((resolve, reject) => {
				let emailReg = new RegExp(/[\w\d]+@[\w\d]+\.[\w\d]+/g);
				if (
					!this.email ||
					!this.checkCode ||
					!emailReg.test(this.email)
				) {
					this.$toast(this.$t("message.login.tips.correctInfo"));
					reject();
				}
				api.email_checkcode({
					email: this.email,
					checkCode: this.checkCode,
				}).then((res) => {
					if (res.code == 0) {
						resolve(true);
					} else {
						this.$toast(res.msg);
						reject();
					}
				});
			});
		},
		emailReset() {
			let emailReg = new RegExp(/[\w\d]+@[\w\d]+\.[\w\d]+/g);
			if (
				!this.email ||
				!this.checkCode ||
				!this.password ||
				!emailReg.test(this.email)
			) {
				this.$toast(this.$t("message.login.tips.correctInfo"));
				return;
			}
			this.emailCheck().then((res) => {
				if (res) {
					if (!this.password) {
						this.$toast(this.$t("message.login.tips.correctInfo"));
						return;
					}
					api.email_reset({
						email: this.email,
						checkCode: this.checkCode,
						password: this.password,
					}).then((res) => {
						if (res.code == 0) {
							this.$toast("Reset password succeeded");
							this.emailBack();
						} else {
							this.$toast(res.msg);
						}
					});
				}
			});
		},
		emailLogin() {
			let emailReg = new RegExp(/[\w\d]+@[\w\d]+\.[\w\d]+/g);
			if (!this.email || !this.password || !emailReg.test(this.email)) {
				this.$toast(this.$t("message.login.tips.correctInfo"));
				return;
			}
			const defaultData = {
				// TODO: 此Id原版代码用的神策的用户id，之后确认具体取值
				anonymousId: this.$sa.store.getDistinctId() || "",
				appVersion: "0.0.0",
				deviceId: getDeviceId(),
				deviceModel: null,
				deviceSystem: 4,
				deviceVersion: "0.0.0",
				relationInfo: this.relationInfo, // TODO: 后续看原版代码确定取值
				loginIp: null,
			};
			api.email_login({
				...defaultData,
				email: this.email,
				password: this.password,
				inviteCode: this.inviteCode,
			}).then((res) => {
				if (res.code == 0) {
					this.setUser(res.result);
					// 需要绑定
					// this.$bindMobile.open({token: res.result.token, userInfo: res.result.intgUser})
				} else {
					this.$toast(res.msg);
				}
			});
		},
		open(loginSuccess) {
			this.emailStatus = EMAIL_STATUS.LOGIN;
			this.loginType = 1;
			this.resetForm();
			this.resetInterval();
			this.visible = true;

			// 登录成功后的回调
			this.loginSuccess = loginSuccess;

			let inviteInfo = getQueryObj();

			if (inviteInfo == null || inviteInfo.activityType != "inviteCode") {
				return;
			}

			this.inviteCode = inviteInfo.code;
		},
		clearInput(){
			if (this.loginType === 1) {
				this.mobile = ""
			}else if (this.loginType === 2) {
				this.email = ""	
			}
		}
	},
	computed: {
		verifyList: function () {
			return this.verifyCode.split("");
		},
		verifyCurrent: function () {
			return this.verifyCode.length;
		},
	},
	watch: {
		verifyCode: function (newV, oldV) {
            if (this.loginType === 1 && newV.length >= 6) {
                this.mobileLogin();
                this.verifyDisable = true;
				this.verifyFocus = false;
            }
            if (this.loginType === 2 && newV.length === 4) {
                this.emailRegister();
                this.verifyDisable = true;
				this.verifyFocus = false;
            }
		},
		mobile: function (newV, oldV) {
            if (newV.length == 0) {
				this.loginErrorInfo = null
            }
		},
		email: function (newV, oldV) {
            if (newV.length == 0) {
				this.emailLoginErrorInfo = null
            }
		},
		visible: function (newV, oldV) {
			if (newV) {
				// Object.assign(this.$data, this.$options.data())
				this.checkSelect = true;
				this.checkSelect1 = false;
			}
			sessionStorage.setItem("loginVisible", newV);
		},
		verifyFocus: function (newV, oldV) {
			if (newV) {
				this.$refs.myInput.focus();
			} else {
				this.$refs.myInput.blur();
			}
		},
	},
};
</script>
<style lang="less" scoped>
.login__form_item{
	::-webkit-input-placeholder{
		color: rgba(155, 155, 155, 1);
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
	}
}
.__conditions_box{
	height: 30px;
	margin: 10px 0;
    padding: 0 44px;
    text-align: center !important;
    color: rgba(0,0,0,0.5);
	a{
		text-decoration: underline;
	}
	a:visited, a:hover, a:active{
		color: #4a4a4a;
	}
	i{
		font-style: normal;
		text-decoration: underline;
	}
}
.conditions_content{
	height: 100%;
	overflow: auto;
	padding: 30px 10px;
	/deep/ p{
		text-align: left;
		line-height: 1.8;
		padding: 10px 0;
		font-size: 14px;
		color: #333;
	}
	/deep/ h1{
		font-size: 24px;
	}
}

.phone_login_content{
	padding-top: 24px;
	// height: 70vh;
    // position: relative;
    // overflow: auto;
    // box-sizing: border-box;
}

h1{
    font-size: 24px;
    color: #000000;
    line-height: 22px;
    padding-bottom: 36px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: normal;
}

.login_panel_btn_back{
    width: 28px;
    height: 28px;
    position: absolute;
    top: 125px;
    left: 18px;
}

._checkbox_wrap{
    vertical-align: middle;
	div.checkbox{
		display: inline-block;
    	vertical-align: middle;
		&.red{
			border: 1px solid #E53636 !important;
		}
	}
	img{
		vertical-align: middle;
	}
}
.login__bottom_item_checktext{
		
    &._title{
        height: 20px;
        line-height: 20px;
        margin-bottom: 10px;
    }
	&_desc {
		text-align: justify;
		font-size: 9px;
		color: #4A4A4A;
		font-family: "Approach-Regular";
	}
}


@keyframes bling {
	100% {
		opacity: 0;
	}
}
@keyframes rotation {

    from {-webkit-transform: rotate(0deg);}

    to {-webkit-transform: rotate(360deg);}
}
@-webkit-keyframes rotation{

    from {-webkit-transform: rotate(0deg);}

    to {-webkit-transform: rotate(360deg);}

}
.login {
	width: 100%;
	height: 100%;
	position: fixed;
	left: 0;
	top: 0;
	z-index: 100;
	background: rgba(0, 0, 0, 0.0);
	background-color: rgba(0, 0, 0, 0.5);
	text-align: center;
	&__verify {
		// width: 375px;
		// height: 434px;
		width: 327px;
		height: 248px;
		background: #FDF4EE;
		border-radius: 8px;
		// position: relative;
		text-align: center;
		overflow: hidden;
		left: 50%;
		transform: translateX(-50%);
		&__close {
            position: relative;
			display: block;
			width: 26px;
			height: 26px;
			margin-right: 17px;
			margin-top: 17px;
			float: right;
			&::after {
				content: "";
				clear: both;
			}
		}
		&__pulldown{
			width: 12px;
            height: 12px;
			margin-left: 6px;
		}
		&__title {
			width: 100%;
			// height: 108px;
            text-align: center;
			font-size: 24px;
			font-family: "Approach-Regular";
			font-weight: 400;
			color: #0D0E13;
            padding: 0 56px;
            box-sizing: border-box;
			margin-top: 40px;
            // display: flex;
            // align-items: center;

		}
		&__sub_title {
			width: 100%;
			height: 19px;
			font-size: 12px;
			font-family: "Approach-Regular";
			font-weight: lighter;
			color: #4A4B4E;
			line-height: 14px;
			padding-top: 5px;
		}
		&__input {
			width: 100%;
			padding: 0;
			// height: 20px;
			font-size: 15px;
			overflow: hidden;
			border: none;
			outline: none;
			opacity: 0;
			margin-left: -100%;
			-webkit-tap-highlight-color: transparent;
			text-indent: -49950px;
		}
		&__body {
			width: 277px;
			height: 40px;
			margin: auto;
			display: flex;
			justify-content: space-between;
			&-email{
				justify-content: center;
			}
		}
		&__item {
			box-sizing: border-box;
			height: 39px;
			line-height: 39px;
			width: 39px;
			border-bottom: solid 0.5px #b0b8bf;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #0D0E13;
			font-size: 24px;
			background-color: white;
			&-active::after {
				content: " ";
				display: inline-block;
				height: 40px;
				width: 2px;
				background: #b0b8bf;
				animation: 0.8s bling infinite;
			}
			&-email{
				margin: 0 4px;
			}
			
		}
		&__send {
			width: 100%;
			height: 23px;
			font-size: 12px;
			font-family: "TradeGothicLT";
			color: #868689;
			line-height: 20px;
			margin: auto;
			margin-top: 10px;
			> span {
				color: #0D0E13;
			}
			&__second {
				color: #4A4B4E;
			}
			&__resend {
				color: #0D0E13;
				font-weight: bold;
			}
		}
	
		&-focus {
			top: 20%;
            // bottom: auto;
			transform: translate3d(-50, -20%, 0);
		}
	}
	&__form_email_status {
		width: 243px;
		height: 20px;
		margin: 0 auto;
		&_solid {
			width: 9px;
			height: 9px;
			display: inline-block;
			background-color: #000000;
			box-sizing: border-box;
			margin: 2.5px;
			border-radius: 9px;
		}
		&_hollow {
			width: 9px;
			height: 9px;
			display: inline-block;
			background-color: transparent;
			box-sizing: border-box;
			border: 1px solid #000000;
			margin: 2.5px;
			border-radius: 9px;
		}
	}
	&__panel {
		position: absolute;
		width: 375px;
		background: #FDF4EE;
		left: 50%;
		transform: translateX(-50%);
		bottom: 0;
		border-top-left-radius: 5px;
		border-top-right-radius: 5px;
		overflow: visible;
		z-index: 110;
		max-height: 551px;
		// border-top: 8px solid #c0ddde;
		// overflow: auto;
		display: flex;
		flex-direction: column;
        .login__title{
            height: 108px;
            background: #000000;
            color: #EFFECE;
            font-size: 36px;
            line-height: 108px;
            text-align: center;
        }
        .sign-up-title{
            padding-top: 36px;
			font-size: 26px;
			font-weight: 400;
			color: #0D0E13;
			line-height: 33px;
			font-family: "Approach-Regular";
        }
		.sign-up-subtitle{
			align-self:center;
			width: 160px;
            padding-top: 5px;
			height: 30px;
			font-size: 12px;
			font-weight: 400;
			color: #4A4B4E;
			line-height: 15px;
			font-family: "Approach-Regular";
        }
        .invite-info{
            padding: 34px 0 0;
            dd{
                border-radius: 100%;
                margin: 0px auto;
                width: 54px;
                height: 54px;
                background-size: cover;
                background-repeat: no-repeat;
                // background-color: #eee;
                background-position:center center;
            }
            dt{
                position: relative;
                font-size: 18px;
                padding: 26px 74px;
                padding-bottom: 10px;
                i{
                    font-weight: bold;
                    font-style: normal;
                }
            }
            .star{
                width: 28px;
                position: absolute;
                top: 20px;
            }
            .star-left {
                left: 50px;
            }
            .star-right {
                right: 50px;
            }
        }
        .head{
            text-align: center;
            padding: 34px 0 0;
            img{
                border-radius: 50%;
                width: 54px;
                height: 54px;
            }
        }
		.login__content{
			flex: 1;
			overflow: scroll;
			display: flex;
			justify-content: center;
			align-items:center;
			flex-direction: column;
		}
		&_close {
			width: 26px;
			height: 26px;
			position: absolute;
			right: 12px;
			top: 12px;
		}
	}
	&__line {
		border: 0;
		padding: 0;
		margin: 0;
		width: 100%;
		height: 8px;
		background: #c0ddde;
	}
	&__brand {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-top: 28px;
		margin-bottom: 24px;
		& img {
			width: 60px;
			height: 60px;
			border-radius: 100%;
			margin-bottom: 8px;
		}
		& span {
			height: 20px;
			font-size: 14px;
			font-family: TradeGothicLT-Bold, TradeGothicLT;
			color: #333333;
			line-height: 20px;
		}
	}
	&__Email {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-top: 32px;
		margin-bottom: 22px;
		& img {
			width: 48px;
			height: 48px;
			border-radius: 100%;
			margin-bottom: 12px;
		}
		& span {
			height: 36px;
			font-size: 24px;
			font-family: TradeGothicNextLTPro-Hv;
			font-weight: bolder;
			color: #000000;
			line-height: 28.99px;
		}
	}
	&__email-back {
		width: 28px;
		height: 28px;
		position: absolute;
		top: 125px;
		left: 18px;
	}
	&__form {
		margin-bottom: 27px;
	}
	&__form_item {
		// background: #f5f5f5;
		// border-radius: 18px;
		// border: 1px solid #f2f2f2;
        border-bottom: 1px solid #979797;
		width: 315px;
		height: 36px;
		line-height: 36px;
		margin: 0 auto 0px;
		box-sizing: border-box;
		text-align: left;
		padding: 0 11px;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		font-family: PingFangSC-Regular, PingFang SC;
		position: relative;
		&_password {
			justify-content: space-between;
		}
		& .area {
			height: 19px;
			line-height: 19px;
			font-size: 16px;
			color: #868689;
		}
		.input_clear_btn {
				border-radius: 9px;
				width: 19px;
				height: 19px;
				position:absolute;
				right: 0;
				top: 6px;
			}
		& input {
			font-size: 16px;
			color: #000;
			border: 0;
			width: 275px;
			height: 19px;
			line-height: 19px;
			border-radius: 0;
			padding: 0 40px 0 0;
			margin-left: 6px;
			// border-left: 1px solid #979797;
			background-color: transparent !important;
			outline: none;
			font-family: "TradeGothicLT";
            text-align: center;
			
			&.vcode {
				border-left: 0;
				padding-left: 0;
				margin-left: 0;
			}
			&.email {
				border-left: 0;
				padding-left: 0;
				margin-left: 0;
				width: 100%;
			}
		}
		&_container {
			background-color: transparent;
			justify-content: space-between;
			padding: 0;
			border: 0;
		}
	}
	&__form_button-vcode {
		width: 83px;
		height: 28px;
		line-height: 28px;
		display: inline-block;
		background: #000000;
		border-radius: 22px;
		font-size: 12px;
		font-weight: normal;
		color: #ffffff;
		text-align: center;
		position: relative;
		right: -7px;
		word-break: keep-all;
		white-space: nowrap;
	}
	&__form_button-forgot {
		// width: 83px;
		height: 20px;
		line-height: 20px;
		display: inline-block;
		font-size: 14px;
		color: #4a4a4a;
		text-align: center;
		position: relative;
		// right: -7px;
		word-break: keep-all;
		white-space: nowrap;
		text-decoration: underline;
	}
	&__form_item-input{
		margin-bottom: 30px;
	}
	&__form_item-errorinfo{
		color: #D52300;
		text-align: center;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 12px;
		
		&_icon{
			width: 12px;
			height: 12px;
			margin: 9px 4px 9px 0;
			border-radius: 12px;
			border: 1px solid #D52300;
			font-size: 10px;
			color: #D52300;
		}
		&_text{
			height: 30px;
			line-height: 30px;
		}
	}
	&__form_item-button {
		border: 0;
		background: #000000;
		border-radius: 30px;
		text-align: center;
		font-size: 14px;
		color: #ffffff;
		justify-content: center;
		width: 347px;
		height: 51px;
		line-height: 51px;
		// box-shadow: 0 2px 4px rgba(0, 0, 0, 0.37);
		&-half {
			width: 118px;
		}
		&-sign_up {
			color: #000000;
			background-color: #ffffff;
			border-radius: 22px;
			border: 1px solid #000000;
		}
		&-disable {
			font-size: 14px;
			justify-content: center;
			width: 347px;
			height: 51px;
			line-height: 51px;
			color: #000000;
			background-color: transparent;
			border-radius: 30px;
			border: 1px solid #0D0E13;
			text-align: center;
		}
	}
	&__bottom {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		margin: 25px 22px 20px;
		&_item {
			display: flex;
			justify-content: flex-start;
			text-align: left;
			margin-bottom: 5px;
			font-family: PingFangSC-Regular, PingFang SC;
			& img {
				width: 18px;
				height: 18px;
				margin-right: 8px;
				border-radius: 7px;
			}
			& div.checkbox {
				flex-shrink: 0;
				width: 18px;
				height: 18px;
				margin-right: 8px;
				border: 1px solid #000000;
				border-radius: 5px;
				box-sizing: border-box;
			}
			&_checktext {
				// height: 18px;
				text-align: left;
				font-weight: 400;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: bold;
				line-height: 14px;
				font-size: 10px;
				color: #4a4a4a;
				&._desc {
					font-weight: normal;
                    a{
                        color: #4a4a4a;
                        text-decoration: underline;
                        &:active{
                            color: #4a4a4a;
                        }
                    }
				}

				& a {
					color: blue;
				}
			}

			& span {
				// height: 18px;
				font-size: 10px;
				color: #4A4A4A;
				line-height: 18px;
				text-align: left;
				// font-weight: 400;
				// font-family: "TradeGothicLT";
				a{
                    color: #000;
				}
			}
		}
	}
	&__other {
        color: rgba(0,0,0,0.5);
        span{
            text-decoration: underline;
        }
		&-head {
			border-top: 1px solid #dcd3c2;
			width: 325px;
			margin: 48px auto 0;
			& div {
				display: inline-block;
				height: 22px;
				font-size: 12px;
				color: #999999;
				line-height: 22px;
				position: relative;
				top: -11px;
				background: #ffffff;
				padding: 0 20px;
				font-family: "TradeGothicLT";
			}
		}
	}
	&__others {
		display: flex;
		justify-content: space-evenly;
		& img {
			width: 40px;
			height: 40px;
		}
		& .img {
			width: 40px;
			height: 40px;
			border-radius: 100%;
		}
	}
	.disable {
		background: #3d3c3c;
	}
	&__code_select {
		position: absolute;
		z-index: 200;
		width: 100%;
		background: #ffffff;
		left: 0;
		bottom: 0;
		border-top: 0.5px solid #aaaaaa;
		border-top-left-radius: 5px;
		border-top-right-radius: 5px;
		height: 200px;
		overflow-y: scroll;
		box-shadow: 0 0 15px #777;
		.country-code-box {
			text-align: left;
			.country-code {
				padding: 20px;
				p {
					margin-bottom: 10px;
					font-size: 10px;
					font-weight: bolder;
				}
				ul {
					li {
						width: 100%;
						height: 40px;
						display: flex;
						align-items: center;
						justify-content: space-around;
						border-bottom: 0.5px solid #e3e3e3;
						span {
							font-size: 12px;
						}
						.name {
							width: 60%;
						}
						.code {
							text-align: right;
							width: 30%;
						}
					}
				}
			}
		}
	}
}

.progress{

    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: -30px;
    margin-left: -20px;
    left: 50%;

    &_indicator{
      width: 9px;
      height: 9px;
      margin-right: 2px;
      margin-left: 2px;
      border-radius: 9px;
      border: 1px solid #ffffff;
      &_mark{
        background-color: #ffffff;
      }
    }
    
  }
</style>
<style lang="less" scoped>
// *{margin:0;padding:0;}
// body{background:#535353;}

.m-load,.m-load2{width:36px;height:36px;}
// .m-load{background:url('load-v1.gif') #535353 center center no-repeat;}
// .m-load2{background:#535353;}

/** 加载动画的静态样式 **/
.m-load2{position:relative;left:50%-5px;}
.m-load2 .line div{position:absolute;left:16px;top:8px;width:3px;height:16px;}
.m-load2 .line div:before,.m-load2 .line div:after{content:'';display:block;height:50%;background:#949393;border-radius:5px;}
.m-load2 .line div:nth-child(2){-webkit-transform:rotate(45deg);}
.m-load2 .line div:nth-child(3){-webkit-transform:rotate(90deg);}
.m-load2 .line div:nth-child(4){-webkit-transform:rotate(135deg);}
// .m-load2 .line div:nth-child(5){-webkit-transform:rotate(120deg);}
// .m-load2 .line div:nth-child(6){-webkit-transform:rotate(150deg);}
.m-load2 .circlebg{position:absolute;left:50%;top:50%;width:10px;height:10px;margin:-7px 0 0 -6px;background:#FDF4EE;border-radius:10px;}

/** 加载动画 **/
@-webkit-keyframes load{
    0%{opacity:0;}
    100%{opacity:1;}
}
.m-load2 .line div:nth-child(1):before{-webkit-animation:load 0.8s linear 0s infinite;}
.m-load2 .line div:nth-child(2):before{-webkit-animation:load 0.8s linear 0.1s infinite;}
.m-load2 .line div:nth-child(3):before{-webkit-animation:load 0.8s linear 0.2s infinite;}
.m-load2 .line div:nth-child(4):before{-webkit-animation:load 0.8s linear 0.3s infinite;}
// .m-load2 .line div:nth-child(5):before{-webkit-animation:load 1.2s linear 0.4s infinite;}
// .m-load2 .line div:nth-child(6):before{-webkit-animation:load 1.2s linear 0.5s infinite;}
.m-load2 .line div:nth-child(1):after{-webkit-animation:load 0.8s linear 0.4s infinite;}
.m-load2 .line div:nth-child(2):after{-webkit-animation:load 0.8s linear 0.5s infinite;}
.m-load2 .line div:nth-child(3):after{-webkit-animation:load 0.8s linear 0.6s infinite;}
.m-load2 .line div:nth-child(4):after{-webkit-animation:load 0.8s linear 0.7s infinite;}
// .m-load2 .line div:nth-child(5):after{-webkit-animation:load 1.2s linear 1s infinite;}
// .m-load2 .line div:nth-child(6):after{-webkit-animation:load 1.2s linear 1.1s infinite;}
</style>